<div class="main-container" data-cy="form-viewer-container">
    <div class="form-container" data-cy="form-viewer-form-container">
      <app-forms-form [absolutePosition]="true" [CaseWorkItemFormsId]="FormId" data-cy="form-viewer-forms-form"></app-forms-form>
    </div>  
  </div>